<div style="margin-left: 2rem">
    <dl class="sh-description-list -sh-vertical">
        <dt class="sh-description-list__term">
            <b>{{ "modules.general.form.location.subfields-dialog-full-address" | translate }}</b>
        </dt>
        <dd class="sh-description-list__details">{{ fullAddress }}</dd>
    </dl>
    <dl class="sh-description-list" style="margin-top: 0">
        <dt class="sh-description-list__term" style="width: 100%; margin-bottom: -0.25rem">
            <b>{{ "modules.general.form.location.subfields-dialog-coordinates" | translate }}</b>
        </dt>
        <dd class="sh-description-list__details">
            <sh-generic-readonly-field [profileField]="profileField" [record]="record" [nestedIndex]="-1"></sh-generic-readonly-field>
        </dd>
    </dl>
</div>
